export default __webpack_public_path__ + "static/media/logo.c4dce5c0.svg";